import { ImageSource } from "../types/upload.types";

export const resolveImageUrl = (file?: ImageSource): string => {
    if (!file) return "";

    if (typeof file === "string") return file;

    if (!("path" in file) || !file.path) return "";

    return typeof file.path === "string"
        ? file.path
        : file.path instanceof Blob
            ? URL.createObjectURL(file.path)
            : "";
};